import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import th from "./languages/th"
import en from "./languages/en"
import { envConfig } from "env"

const CURRENT_LANG_KEY = "CURRENT_LANG_KEY"
export const getCurrentLang = () => {
  const lang = localStorage.getItem(CURRENT_LANG_KEY)
  if (lang) {
    return lang
  }
  setCurrentLang(envConfig.REACT_APP_DEFAULT_LANG)
  return envConfig.REACT_APP_DEFAULT_LANG
}

export const setCurrentLang = (lang: string | undefined) => {
  if (lang) {
    localStorage.setItem(CURRENT_LANG_KEY, lang)
  }
}

const initialLng = getCurrentLang()

/** Bundled strings only — avoids blocking first paint on /translate/{lng} (often 2s+ on UAT). */
i18next.use(initReactI18next).init({
  lng: initialLng,
  fallbackLng: envConfig.REACT_APP_DEFAULT_LANG,
  debug: process.env.NODE_ENV === "development",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    th: { translation: th.translation },
    en: { translation: en.translation },
  },
})

export const langs = ["en", "th"]

i18next.on("languageChanged", (lang: string) => {
  setCurrentLang(lang)
})

export default i18next
